import Form from "./Form";
import { useToast } from "@chakra-ui/react";
import {
  CreatePageMutationVariables,
  useCreatePageMutation,
  useCreateNewsMutation,
  CreateNewsMutationVariables,
} from "../../generated/graphql";
import { useNavigate } from "react-router-dom";

const Create = () => {
  const [createNews] = useCreateNewsMutation();
  const navigation = useNavigate();
  const toast = useToast();
  const handleCreateNews = async (data: CreateNewsMutationVariables) => {
    try {
      await createNews({
        variables: {
          data: data.data,
        },
      });

      return toast({
        status: "success",
        title: "Success",
        description: "News added",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/news");
        },
      });
    } catch (error) {
      return toast({
        status: "error",
        title: "Error",
        description: "An error occured",
        duration: 1000,
      });
    }
  };
  return <Form handleCreateNews={handleCreateNews} actionType="CREATE" />;
};

export default Create;
